var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/load/thermal.template.html');
var OpaqueTable = require("views/opaque_building_table.view.ts");
var GlazingTable = require("views/glazing_building_table.view.ts");

var TheView = GenericView.extend({
    el: '#thermal',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "thermal");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);

        this.opaqueTable = new OpaqueTable();
        this.glazingTable = new GlazingTable();
    },
    events: {
        "change input.slider": "fillTextBoxWithSliderValue",
        "input .input-slider": "changeSliderValue",
        "input .to-validation input": "validateIt",
        "click .more-info": "showInfo",
    },
    fillTextBoxWithSliderValue: function(event) {
        $input_id = $(event.currentTarget).data("input-id");
        $input_value = $(event.currentTarget).val();
        $("#" + $input_id).val($input_value);
    },
    changeSliderValue: function(event) {
        var slider_data_id = $(event.currentTarget).attr('id');
        var input_value = $(event.currentTarget).val();
        $('[data-input-id="' + slider_data_id + '"]').val(input_value);
    },
    getAllData: function() {
        var data = {
            temp_h: this.convertToFloat("#temp_h"),
            temp_c: this.convertToFloat("#temp_c"),
            f_max: this.convertToFloat("#f_max"),
            c_max: this.convertToFloat("#c_max"),
            opaque_building_elements: this.getAllOpaqueElements(),
            glazing_building_elements: this.getAllGlazingBuildingElements(),
            q_V: this.convertToFloat("#q_V"),
            q_I: this.convertToFloat("#q_I"),
            q_occupants: this.convertToFloat("#q_occupants"),
            q_appliances: this.convertToFloat("#q_appliances"),
            f_int: this.convertToFloat("#f_int"),
            f_sol: this.convertToFloat("#f_sol"),
            f_H: this.convertToFloat("#f_H")
        };

        return data;
    },
    getAllOpaqueElements: function() {
        var self = this;
        var listOfElements = [];

        var rows = $("#opaqueBuilding").find(".opaque_row");

        $.each(rows, function(index, value) {
            var temp = {
                building_element: $(this).find(".building_element").val(),
                opaque_building_type_of_element: $(this).find(".opaque_building_type_of_element").val(),
                a_elem: self.convertToFloat($(this).find(".a_elem")),
                u_value: $(this).find(".u_value").val(),
                type_of_distribution: $(this).find(".type_of_distribution").val(),
                a_sol: $(this).find(".a_sol").val(),
                gamma: self.convertToFloat($(this).find(".gamma")),
                beta: self.convertToFloat($(this).find(".beta")),
                class_of_element: $(this).find(".class_of_element").val()
            };

            listOfElements.push(temp);
        });

        return listOfElements;
    },
    getAllGlazingBuildingElements: function() {
        var self = this;
        var listOfElements = [];

        var rows = $("#glazingBuilding").find(".glazing_row");

        $.each(rows, function(index, value) {
            var temp = {
                opaque_element_number: self.convertToInt($(this).find(".opaque_element_number")),
                glazing_building_type_of_element: $(this).find(".glazing_building_type_of_element").val(),
                a_glaz: self.convertToFloat($(this).find(".a_glaz")),
                structure_of_element: $(this).find(".structure_of_element").val()
            };

            listOfElements.push(temp);
        });

        return listOfElements;
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    showInfo: function() {

            $.notify.addStyle('foo', {
              html:
                "<div>" +
                  "<div class='clearfix'>" +
                    "<div class='i'><i class='fa fa-info-circle'></i></div>" +
                    "<div class='title' data-notify-html='title'></div>" +
                    "<div class='message'>" +
                      "<div>Fill in all the table cells for each one of the Opaque Building Elements. To add a new element in the table, press the + button.</div>" +
                      "<div class='bold'>Please, start by providing data for the Floor and the Basement wall of your building, following this order.</div>" +
                      "<div class='bold'>Provide only 1 (one) element for the Floor and 1 (one) for the Basement wall.</div>" +
                    "</div>" +
                  "</div>" +
                "</div>"
            });

            $.notify({
              title: 'Info',
            }, {
              style: 'foo',
              autoHide: false,
              clickToHide: true,
              showAnimation: 'slideDown',
              hideAnimation: 'slideUp',
              globalPosition: 'top left',
            });

    }
});

module.exports= TheView;